import React from 'react';

import SectionMessage from '@atlaskit/section-message';

import { DownloadLogs } from '../DownloadLogs';
import { SeeCreatedTests } from '../SeeCreatedTests';
import {
  ImportSummaryStyled,
  SectionMessageStyled,
} from './ImportSummaryTable.styled';

export const ImportSummaryTableView = ({ errorsCount, successCount }: any) => {
  return (
    <ImportSummaryStyled>
      {successCount > 0 && (
        <SectionMessage appearance='success'>
          <SectionMessageStyled>
            {successCount} QAlity Test issue/s created successfully
            <SeeCreatedTests />
          </SectionMessageStyled>
        </SectionMessage>
      )}
      {errorsCount > 0 && (
        <SectionMessage appearance='error'>
          <SectionMessageStyled>
            {errorsCount} QAlity Test issue/s weren’t created due to errors
            <DownloadLogs />
          </SectionMessageStyled>
        </SectionMessage>
      )}
    </ImportSummaryStyled>
  );
};
